import React, { Component } from "react";
import AddAnnounceType from '../../components/Admin/addHebergement'
import AddAnnounceCar from '../../components/Admin/addCar'
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { addAnn, addVisa } from "../../slices/modalSlice";
import Calender from '../../components/common/calender';
import DashCatego from "../../components/Admin/dashCatego";
import DashMenuItem from "../../components/Admin/dashMenuItem";
import DashAnnounce from "../../components/Admin/dashAnnounce";
import Depositesolde from "../../components/Admin/depositeSolde";
import AddVoyageAnnounce from "../../components/common/Voyages/addVoyage";
import AddVisaAnnounce from "../../components/common/Visas/AddVisaAnnounce";
import AddTransfertModal from "../../components/common/Cars/addTransfertModal";


class Agent extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      isoOpenHeberg:false,
      isOpenAddanc:false
     }
}


openTypeAnnounceForm = () =>{
this
.props
.dispatch(addAnn())
}
  render() {
    const cuurentUser = this.props.currentUser
    console.log(cuurentUser._id);

    return (
    <div>

    {/* Window Add Announce */}
    <AddAnnounceType  idOwner={cuurentUser._id}/>
    <AddAnnounceCar />
    <AddVoyageAnnounce idOwner={cuurentUser._id}/>
    <AddVisaAnnounce/>
    <AddTransfertModal />
    
    <div className="container d-flex pt-4">
      <div className="dash__menus col-8 px-0 ">
          <div className="bienvenu__container ">
            <DashCatego name="Bienvenu L&B!" />
            <div className="dash__menu d-flex justify-content-between col-9 mt-5">
               <div onClick={this.openTypeAnnounceForm.bind(this)}><DashMenuItem  icon="/imgs/dashboard/add.svg" txt="Nouvelle  Annonce" size="50px"  rotate="{ rotate: '180deg'}" /></div>
              <DashMenuItem icon="/imgs/dashboard/profile.svg" txt="Profil" size="50px" link="/agent/profile"/>
              <DashMenuItem icon="/imgs/dashboard/announces.svg" txt="Annonces" size="50px" link="/agent/annonces"/>
              <DashMenuItem icon="/imgs/dashboard/wallet.svg" txt="Portefeuille" size="50px"/>
              <DashMenuItem icon="/imgs/dashboard/pub.svg" txt="Publicités" size="50px" link="/agent/profileSettings"/>
            </div>
          </div>
          <div className="parcourir__container  mt-4">
            <DashCatego name="Parcourir les annonces" />
           
            <div className="dash__menu d-flex justify-content-between col-10 mt-5">
              <DashMenuItem icon="/imgs/dashboard/heberg.svg" txt="Hébergements" size="50px" link="/hebergement" />
              <DashMenuItem icon="/imgs/dashboard/vols.svg" txt="Vols" size="50px" link="/vols" />
              <DashMenuItem icon="/imgs/dashboard/visas.svg" txt="Visa" size="50px" link="/visas" />
              <DashMenuItem icon="/imgs/dashboard/voyage.svg" txt="Voyages" size="50px" link="/voayage" />
              <DashMenuItem icon="/imgs/dashboard/cars.svg" txt="Véhicules" size="50px" link="/cars" />
              <DashMenuItem icon="/imgs/dashboard/divert.svg" txt="Loisir & Divers" size="50px" link="/home" />
            </div>
          </div>
      </div>
      <div className="col-4 pl-5 pr-0">
        <div className="deposite__card">
          <div className="deposite__head">
            <div className="deposite__tot d-flex justify-content-center align-items-center py-4">
              <span className="mr-2">DZD</span>
              <h2 className="tot__txt">500 000.00</h2>
            </div>
          </div>
          <div className="deposite__body">
            <div className="deposite mt-3">
              <Depositesolde win="#182952" solde="500 000"/>
              <Depositesolde lose="#C58F12" solde="300 000"/>
              <Depositesolde win="#182952" solde="340 000"/>
              <Depositesolde lose="#C58F12" solde="10 000"/>
              <Depositesolde win="#182952" solde="1 000"/>
              <Depositesolde lose="#C58F12" solde=" 10 000"/>
            </div>
            <div className="d-flex justify-content-center mt-4">
            <img src="/imgs/dashboard/deposite_add.svg"  alt="" />
            </div>

          </div>
        </div>
      </div>
      </div>
      <div className="dash__ann container mt-5">
            <DashCatego name="Mes annonces"/>
           
            <div className="dash__ann__stat mb-3  row d-flex align-items-center">
              <div className="col-5 ">


                <Calender returnBool={true}/>
               
              </div>
              
              <div className="ann__stats col-7 row px-0 mx-0">
                <div className="nbr__stats d-flex flex-column align-items-center col-4">
                  <span><span className="stats__big">16</span><span className="stats__sm">/25</span></span>
                  <span className="stats__sm__txt">Réservations Actuels</span>
                </div>
                <div className="nbr__stats d-flex flex-column align-items-center col-4">
                  <span className="stats__big">1450</span>
                  <span className="stats__sm__txt">Vues</span>
                </div>
                <div className="nbr__stats d-flex flex-column align-items-center col-4">
                  <span><span className="stats__big">4</span><span className="stats__sm">/25</span></span>
                  <span className="stats__sm__txt">Annonces Online</span>
                </div>
              </div>
            </div>
            <DashAnnounce name="Appartement F3 Laarbi Ben Mhidi" actual="2" all="6" vues="435" id="ee" share={false}/>
            <DashAnnounce name="Appartement F3 Laarbi Ben Mhidi" actual="2" all="6" vues="435" id="dd" share={false}/>
            <DashAnnounce name="Appartement F3 Laarbi Ben Mhidi" actual="2" all="6" vues="435" id="ss" share={false}/>
          
         
            
       
      
      
    </div>














    {/* <Container>
       <Row>
         
           <div className="block">
             <div className="title-agence">
               <h2 className="title-block-agent">Bienvenu L&B</h2>
             </div>
            <section className="tasks-line">
            <div className="circle-task"
              onClick={this.openTypeAnnounceForm} 
            >
            <span  type="button"><span className="text-Pro">
            <FontAwesomeIcon className="icon" icon={faPlus} />
            </span></span>
            <div className="circle-title">Nouvelle Annonces</div>
            </div>
            
            <div className="circle-task"> 
            <NavLink href='/agent/profile'>
              <span  type="button"><span className="text-Pro">
            <FontAwesomeIcon className="icon" icon={faUserCircle} />
            </span></span>
            <div className="circle-title">
              Profile 
            </div>
            </NavLink>
            </div>
           
           <div className="circle-task">
           <span  type="button"><span className="text-Pro">
            <FontAwesomeIcon className="icon" icon={faHistory} />
            </span></span>
            <div className="circle-title">Historique</div>
           </div>
            
            <div className="circle-task">
              <span  type="button"><span className="text-Pro">
            <FontAwesomeIcon className="icon" icon={faBullhorn} />
            </span></span>
            <div className="circle-title">Publicité</div>
            </div>
            
            <div className="circle-task">
            <span  type="button"><span className="text-Pro">
            <FontAwesomeIcon className="icon-sousAgent" icon={faUsers} />
            </span></span>
            <div className="circle-title">Sous-Agents</div>
            </div>
            
             </section>
           </div>
       </Row>
       <Row>
       <div className="block">
            <div className="title-agence">
               <h2 className="title-block-agent">Annonces Pro</h2>
             </div>
            <section>
            <div className="circle-task">
            <span  type="button"><span className="text-Pro">
            <FontAwesomeIcon className="icon" icon={faBed} />
            </span></span>
            <div className="circle-title">Hebergement</div>
            </div>
            
            <div className="circle-task"> 
              <span  type="button"><span className="text-Pro">
            <FontAwesomeIcon className="icon" icon={faPlane} />
            </span></span>
            <div className="circle-title-small">Vols </div>
            </div>
           
           <div className="circle-task">
           <span  type="button"><span className="text-Pro">
            <FontAwesomeIcon className="icon" icon={faPaperPlane} />
            </span></span>
            <div className="circle-title-small">Visas</div>
           </div>
            
            <div className="circle-task">
              <span  type="button"><span className="text-Pro">
            <FontAwesomeIcon className="icon" icon={faBus} />
            </span></span>
            <div className="circle-title">Voyages</div>
            </div>
            
            <div className="circle-task">
            <span  type="button"><span className="text-Pro">
            <FontAwesomeIcon className="icon" icon={faCar} />
            </span></span>
            <div className="circle-title">Vehicules</div>
            </div>
            
            <div className="circle-task">
            <span  type="button"><span className="text-Pro">
            <FontAwesomeIcon className="icon" icon={faMapSigns} />
            </span></span>
            <div className="circle-title">Loisires</div>
            </div>
             </section>
           </div>
       </Row>
       <Row>
           <div className="block">
           <div className="title-agence">
               <h2 className="title-block-agent">Activité</h2>
             </div>
           <section className="activite">
            </section>
           </div>
       </Row>
    </Container>
 */}


    </div>

    );
  }
}


function mapStateToProps(state) {
  return {
    /*
    isOpenAddanc: state.counterApp.isOpenAddanc,
    */
  }
}

//connect function INJECTS dispatch function as a prop!!
export default withRouter(connect(mapStateToProps)(Agent));